import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-hu.jpg'
import _imports_1 from '@/assets/logo-ro.jpg'
import _imports_2 from '@/assets/logo-en.jpg'


const _withScopeId = n => (_pushScopeId("data-v-ffb96b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form-container" }
const _hoisted_2 = { class: "app-center-content-horizontal" }
const _hoisted_3 = {
  key: 0,
  class: "logo-container",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "logo-container",
  src: _imports_1
}
const _hoisted_5 = {
  key: 2,
  class: "logo-container",
  src: _imports_2
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app-center-content-horizontal title_portal" }, "PORTAL PARTENERI", -1))
const _hoisted_7 = {
  key: 0,
  style: {"padding":"2rem"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "input-container title_autentificare"
}
const _hoisted_10 = {
  key: 1,
  class: "input-container title_autentificare"
}
const _hoisted_11 = { class: "input-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.2rem"} }, "Utilizator", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "input-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.2rem"} }, "Parola", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.2rem"} }, "Confirma Parola", -1))
const _hoisted_19 = { class: "btn-container" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "app-center-content-horizontal"
}
const _hoisted_22 = {
  key: 1,
  class: "app-center-content-horizontal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.selectedLang == 'hu')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.selectedLang == 'ro')
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.selectedLang == 'en')
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _hoisted_6,
    (_ctx.isUserAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          (_ctx.type == '1')
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Setare Parola"))
            : _createCommentVNode("", true),
          (_ctx.type == '2')
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Resetare Parola"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createVNode(_component_q_input, {
              placeholder: "Utilizator",
              outlined: "",
              style: {"max-height":"7vh","font-size":"1.2rem"},
              modelValue: _ctx.user,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event)),
              onKeydown: _withKeys(_withModifiers(_ctx.focusOnPassword, ["prevent"]), ["enter"]),
              "lazy-rules": "",
              dense: "",
              disable: ""
            }, null, 8, ["modelValue", "onKeydown"])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_q_input, {
              placeholder: "Parola",
              outlined: "",
              style: {"max-height":"7vh","font-size":"1.2rem"},
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              type: _ctx.isPwd ? 'password' : 'text',
              onKeydown: _withKeys(_withModifiers(_ctx.focusOnBtnLogin, ["prevent"]), ["enter"]),
              ref: "refPassword",
              "lazy-rules": "",
              dense: "",
              rules: [val => !!val || 'Camp obligatoriu']
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                  class: "cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPwd = !_ctx.isPwd))
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["modelValue", "type", "onKeydown", "rules"]),
            _hoisted_17,
            _hoisted_18,
            _createVNode(_component_q_input, {
              placeholder: "Confirma Parola",
              outlined: "",
              style: {"max-height":"7vh","font-size":"1.2rem"},
              modelValue: _ctx.confirmPassword,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              type: _ctx.isPwd ? 'password' : 'text',
              onKeydown: _withKeys(_withModifiers(_ctx.focusOnBtnLogin, ["prevent"]), ["enter"]),
              ref: "refPassword",
              "lazy-rules": "",
              dense: "",
              rules: [val => !!val || 'Camp obligatoriu']
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                  class: "cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPwd = !_ctx.isPwd))
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["modelValue", "type", "onKeydown", "rules"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.type == '1')
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  "no-caps": "",
                  label: "Setare Parola",
                  color: "#273233",
                  loading: _ctx.ajaxIsLoading,
                  "text-color": "black",
                  ref: "refBtnLogin",
                  onClick: _ctx.onSubmitLoginData
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.type == '2')
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  "no-caps": "",
                  label: "Resetare Parola",
                  color: "#273233",
                  loading: _ctx.ajaxIsLoading,
                  "text-color": "black",
                  ref: "refBtnLogin",
                  onClick: _ctx.onSubmitLoginData
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_ctx.type == '1')
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Token invalid, setare parola anulata"))
            : _createCommentVNode("", true),
          (_ctx.type == '2')
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Token invalid, resetare parola anulata"))
            : _createCommentVNode("", true)
        ]))
  ]))
}